import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import intervalPlural from 'i18next-intervalplural-postprocessor';
// import Backend from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
import { LANG_DEFAULT } from '.';

import uk from '@/locales/uk/uk.json';
import ru from '@/locales/ru/ru.json';

i18next
  .use(initReactI18next)
  .use(intervalPlural)
  .init({
    lng: LANG_DEFAULT,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    resources: {
      uk: {
        translation: uk,
      },
      ru: {
        translation: ru,
      },
    },
  });

// i18n
//   // .use(Backend)
//   // .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({
//     fallbackLng: LANG_DEFAULT,
//     debug: false,
//     detection: {
//       order: ['queryString', 'cookie'],
//       cache: ['cookie'],
//     },
//     interpolation: {
//       escapeValue: false,
//     },
//     react: {
//       useSuspense: false,
//     },
//   });

export default i18next;
